export class CustomerList {
    public customerId: number;
    public customerName: string;
}

export class JobsiteList {
    public jobsiteId: number;
    public jobsiteName: string;
    public equipmentCount: number;
    public implementCount: number;
}

export class ChangeImplementJobsiteData {
    public implementId: number;
    public customerId: number;
    public jobsiteId: number;
    public cost: number;
    public date: Date;
    public comment: string;
}